import SuperagentApi from '../assets/utils/superagent'

const modelSetting = Wiz.globalSettings?.globalConfig?.modelSetting || {}
const preloadApi = new SuperagentApi({ baseUrl: modelSetting.preloadServer })
const cloudApi = new SuperagentApi({
  baseUrl: `${modelSetting.cloudProtocol === 'wss' ? 'https' : 'http'}://${
    modelSetting.cloudServerPath
  }`,
})
export default class preloadService {
  // 获取引擎节点
  static async getEngineId(payload) {
    const [err, res] = await preloadApi.post('/api/preload/distribute-node', { data: payload })
    return [err, res]
  }
  // 更新模型加载历史
  static async historyConfiguration(payload) {
    const [err, res] = await preloadApi.post('/api/preload/history-configuration', {
      data: payload,
    })
    return [err, res]
  }
  // 强制终止引擎
  static async forceTerminate(payload) {
    const [err, res] = await cloudApi.get('/kill', {
      params: { ...payload },
    })
    return [err, res]
  }
}
